import React, { useEffect, useRef } from "react";
import "./Checkbox.scss";

const Checkbox = ({ checked = false, onChange, indeterminate = false, disabled = false, label, className = "" }) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);

    return (
        <label className={`checkbox-wrapper ${disabled ? "disabled" : ""} ${className}`}>
            <input
                ref={inputRef}
                type="checkbox"
                className="checkbox-native"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
            <span className="checkbox-box">
                {indeterminate
                    ? <span className="icon checkbox-icon" data-icon="remove" />
                    : checked && <span className="icon checkbox-icon" data-icon="check" />
                }
            </span>
            {label && <span className="checkbox-label">{label}</span>}
        </label>
    );
};

export default Checkbox;
